export default "__VITE_ASSET__0KOKYlZM__"